import { useEffect, useState } from "react";
import { DataService } from "../../../services/DataService";
import { ColumnBuilder } from "./ColumnBuilder";
import { defaultExcelStyle } from "../../../utils/AgGridUtils/defaultExcelStyle";
import { DataTable } from "../../ui/DataTable";
import { ModuleRegistry } from "ag-grid-community";
import {
  AllCommunityModule,
  ExcelExportModule,
  ClientSideRowModelModule,
  ValidationModule,
  RowGroupingModule,
  RowGroupingPanelModule,
  CellSelectionModule,
  ClipboardModule,
} from "ag-grid-enterprise";
import { _ROUTES } from "../../../utils/_routes_constants";
import { useSalesOnCellValueChanged } from "./useSaveSalesOnCellChanged";
import CustomGroupHeader from "../sales-filaire/CustomGroupHeader";
import { _COLORS } from "../../../utils/constants";
import { parseInternationalNumber } from "../BaseBudgetSaveFunctions";

ModuleRegistry.registerModules([
  AllCommunityModule,
  ExcelExportModule,
  ClientSideRowModelModule,
  ValidationModule,
  RowGroupingModule,
  RowGroupingPanelModule,
  CellSelectionModule,
  ClipboardModule,
]);

export const PROD_LRL_WASTE_TONS =
  "PRODUCTION LRL including waste as source - Tons";
export const EXCAVATOR_SUBCONTRACTOR = "EXCAVATOR COST (SUBCONTRACTOR) - Rs/T";
export const LORRIES_TRANSPORT_RS_T = "LORRIES TRANSPORT COST - Rs/T";
export const EXCAVATOR_LRU_RS_T = "EXCAVATOR COST (LRU) - Rs/T";
export const PLUMS_RS_T = "PLUMS COST - Rs/T";
export const DIESEL_IMPACT = "Diesel Impact";
export const TOTAL_COST_RS_T = "Total Cost Rs/T";
export const PLUMS_COST_RS = "PLUMS COST - RS.";
export const LORRIES_TRANSPORT_RS = "LORRIES TRANSPORT COST - RS.";
export const EXCAVATOR_LRU_RS = "EXCAVATOR COST (LRU) - Rs.";

/**
 * @description Array of theme that include rate and diesel impact
 */
export const ARRAY_INCLUDE_RATE_DIESEL = [
  EXCAVATOR_SUBCONTRACTOR,
  LORRIES_TRANSPORT_RS_T,
  EXCAVATOR_LRU_RS_T,
];

/**
 * @description Array of theme that include total cost value (tons * rate)
 */
export const ARRAY_INCLUDE_TOTAL_COST_VALUE = [
  PLUMS_COST_RS,
  LORRIES_TRANSPORT_RS,
  EXCAVATOR_LRU_RS,
];

export const AgGridQuarryingExcavator = ({ params, gridRef }) => {
  const dataService = new DataService();
  const [rowsData, setRowsData] = useState([]);
  const [pendingRefresh, setPendingRefresh] = useState(false);
  const [columns] = useState(() => ColumnBuilder({}));
  const excelStyles = defaultExcelStyle();

  const handleCellChange = useSalesOnCellValueChanged(
    params,
    setPendingRefresh,
    gridRef,
  );

  useEffect(() => {
    dataService.fetchData(_ROUTES.IPT_SALE_QUARRYING_GROUP, params, (data) => {
      const transformedRows = data
        .map((themeData) =>
          themeData.subThemes.map((subTheme) => {
            const row = {
              theme: themeData.theme,
              subThemes: subTheme.name,
              rate: subTheme.rate,
              total: 0,
              inputs: {},
            };

            for (let i = 1; i <= 12; i++) {
              row[i] = null;
            }

            subTheme.inputs.forEach((input) => {
              row[input.fiscalMonth] = input.value;
              row.inputs[input.fiscalMonth] = input.id;
            });

            return row;
          }),
        )
        .flat();

      setRowsData(transformedRows);
    });
  }, [params.site, params, pendingRefresh]);

  const defaultColDef = {
    valueParser: (params) => {
      // Parser pour tous les champs éditables numériques
      if (params.colDef.editable && typeof params.newValue === "string") {
        return parseInternationalNumber(params.newValue);
      }
      return params.newValue;
    },
    cellClassRules: {
      "blank-row": (params) => {
        return params.data?._SPACER;
      },
      "total-row": (params) =>
        params.node && params.node.aggData && params.node.footer,
      "total-header-col": (params) => {
        return params.colDef.field === "total";
      },
      "editable-cell": (params) => {
        if (!params.data || params.colDef.field === "total") {
          return false;
        }
      },
      "diesel-cell": (params) => {
        return params.data?.subThemes === "Diesel Impact";
      },
    },
  };

  return (
    <>
      <DataTable
        rows={rowsData}
        columns={columns}
        excelStyles={excelStyles}
        onCellValueChanged={handleCellChange}
        fullHeight={true}
        rowHeight={30}
        fileNameCsvExport={"sale-depot"}
        gridRef={gridRef}
        agGridProps={{
          cellSelection: true,
          copyHeadersToClipboard: false,
          defaultColDef: defaultColDef,
          groupDisplayType: "groupRows",
          groupDefaultExpanded: -1,
          suppressAggFuncInHeader: true,
          suppressClipboardPaste: false,
          enableCellTextSelection: true,
          ensureDomOrder: true,
          groupRowRendererParams: {
            suppressCount: true,
          },
          groupTotalRow: (p) =>
            ARRAY_INCLUDE_TOTAL_COST_VALUE.includes(p?.node?.key)
              ? "bottom"
              : undefined,
          getRowClass: (params) => {
            if (!params.data) return "header-group-row";

            if (params.data?.subThemes === PROD_LRL_WASTE_TONS) {
              return "production-lrl-quarrying-cell";
            }

            return "";
          },
          groupRowRenderer: (node) => (
            <CustomGroupHeader
              node={node}
              style={{ color: _COLORS.groupTitleColor }}
              empty={node.value === PROD_LRL_WASTE_TONS}
            />
          ),
        }}
      />
    </>
  );
};
